module.exports = __webpack_public_path__ + "ng.svg?f9abfac27e4762fa325182457abfeb5f";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ng.svg
// module id = 1339
// module chunks = 27